import script from "./uploadPicDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./uploadPicDialog.vue?vue&type=script&lang=ts&setup=true"

import "./uploadPicDialog.vue?vue&type=style&index=0&id=6f045245&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f045245"]])

export default __exports__